import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import * as echarts from "echarts";
import { isEmpty } from "@/utils/shared";
export default {
  name: "EvalidatePlace",
  props: ["source", "id"],
  watch: {
    source: function source() {
      this.init();
    },
    id: function id() {
      this.echart && this.echart.resize();
    }
  },
  data: function data() {
    return {
      echart: null
    };
  },
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;
      if (isEmpty(this.echart)) {
        this.echart = echarts.init(document.getElementById("evalidatePlace"));
      }
      var echart = this.echart;
      var color = "#F9FAFA";
      echart.setOption({
        legend: {
          orient: "vertical",
          top: "5%",
          right: "6%",
          data: ["次数", "人数"],
          itemHeight: this.size(14),
          itemWidth: this.size(14),
          itemGap: parseInt(this.size(16)),
          textStyle: {
            fontSize: this.size(12),
            color: color,
            padding: [0, 0, 0, this.size(4)]
          },
          itemStyle: {
            decal: "none"
          }
        },
        grid: {
          top: "15%",
          bottom: "14%",
          right: "26%"
        },
        xAxis: {
          type: "category",
          data: ["门诊评估", "病房评估", "上门评估"],
          axisLabel: {
            color: color,
            fontSize: this.size(12)
          }
        },
        yAxis: {
          name: "单位：次",
          type: "value",
          nameTextStyle: {
            color: "#fff",
            opacity: 0.5,
            fontSize: this.size(12)
          },
          axisLabel: {
            color: color,
            fontSize: this.size(12)
          }
        },
        series: [{
          name: "次数",
          type: "bar",
          itemStyle: this.getBarStyle("#0B9FBF", "#3874E1"),
          label: {
            show: true,
            position: "top",
            color: "#27A8FF"
          },
          emphasis: {
            disabled: true
          },
          data: ["mzNum", "bfNum", "smNum"].map(function (key) {
            return _this.source[key] || 0;
          }),
          barWidth: "20%"
        }, {
          name: "人数",
          type: "bar",
          itemStyle: this.getBarStyle("#0AAE91", "#0B9CBD"),
          label: {
            show: true,
            position: "top",
            color: "#2DFFDB"
          },
          emphasis: {
            disabled: true
          },
          data: ["mzPerson", "bfPerson", "smPerson"].map(function (key) {
            return _this.source[key] || 0;
          }),
          barWidth: "20%"
        }]
      });
    },
    size: function size(sz) {
      return sz / 14 * document.documentElement.style.fontSize.slice(0, -2);
    },
    getBarStyle: function getBarStyle(c1, c2) {
      return {
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
            offset: 0,
            color: c1 // 0% 处的颜色
          }, {
            offset: 1,
            color: c2 // 100% 处的颜色
          }]
        },

        decal: {
          symbol: "roundRect",
          symbolSize: 0.4,
          color: "#000",
          dashArrayX: [1, 0],
          dashArrayY: [2]
        }
      };
    }
  }
};